import React from "react";
import PropTypes from "prop-types";
import { Grid, Skeleton } from "@mui/material";
import { colors, borderRadiusPx } from "../../../../../theme";

const AllMissileSkeleton = ({ count = 6 }) => {
  return (
    <Grid container spacing={3}>
      {Array.from({ length: count }).map((_, index) => (
        <Grid item xs={12} sm={6} lg={4} key={index}>
          <Skeleton
            variant="rounded"
            height={440}
            animation="wave"
            sx={{
              bgcolor: colors.slate[200],
              borderRadius: borderRadiusPx.xl,
            }}
          />
        </Grid>
      ))}
    </Grid>
  );
};

AllMissileSkeleton.propTypes = {
  count: PropTypes.number,
};

export default AllMissileSkeleton;
